import React, { useState, useContext, useEffect } from "react";
import "./styles.css";
import axios from "axios";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ScriptsModal, { ReviewModal, aplicarVariaveis } from "../scriptsModal";
import api from "../../../../../services/api";
import EmpresaContext from "../../../../../contexts/Empresa";

const actions = [
  {
    key: "scripts",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
    label: "Scripts de Venda",
    subtitle: "Encontre insights para abordar sua oportunidade",
  },
  {
    key: "perseguicao",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
      </svg>
    ),
    label: "Enviar para Perseguição",
    subtitle: "Posso te ajudar a reengajar esse cliente caso ele tenha parado de responder",
  },
  {
    key: "indicacao",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    label: "Programa de Indicação",
    subtitle: "Posso pedir indicação para esse cliente automaticamente",
  },
  /* Registrar Comentário — desativado temporariamente
  {
    key: "comentario",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
        <line x1="8" y1="23" x2="16" y2="23" />
      </svg>
    ),
    label: "Registrar Comentário",
    subtitle: "Dite notas de reunião instantaneamente",
  },
  */
];

const CopilotSidebar = ({ isOpen, onClose, oportunidade }) => {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [scriptsOpen, setScriptsOpen] = useState(false);
  const [indicacaoAction, setIndicacaoAction] = useState(null);
  const [loadingIndicacao, setLoadingIndicacao] = useState(false);
  const [loadingPerseguicao, setLoadingPerseguicao] = useState(false);
  const [alert, setAlert] = useState(null);
  const [webhookUrlPerseguicao, setWebhookUrlPerseguicao] = useState(null);

  useEffect(() => {
    if (!isOpen || !empresaSelecionada?.id) return;
    api
      .get(`automacoes/${empresaSelecionada.id}/perseguicao`)
      .then((res) => setWebhookUrlPerseguicao(res.data?.webhook_url || null))
      .catch(() => setWebhookUrlPerseguicao(null));
  }, [isOpen, empresaSelecionada?.id]);

  if (!isOpen) return null;

  const nomeOportunidade = oportunidade?.title || oportunidade?.nome || "Oportunidade";

  async function handleIndicacao() {
    setLoadingIndicacao(true);
    try {
      const res = await api.get("/marketing/modelos-sites/usuario");
      const link = res.data?.indicacao?.link || "";
      const template = `Olá, [Nome]! Tudo bem?\nQuero te convidar para participar do meu programa de indicação.\nAo me indicar novos contatos que possam ter interesse no que oferecemos, você pode receber uma bonificação por cada oportunidade gerada.\n\nAcesse meu link exclusivo e veja como funciona:\n${link}\n\nSe quiser, também posso te explicar rapidinho por aqui.`;
      const texto = aplicarVariaveis(template, oportunidade);
      setIndicacaoAction({ texto, type: "whatsapp" });
    } catch (err) {
      console.error("Erro ao buscar link de indicação", err);
    } finally {
      setLoadingIndicacao(false);
    }
  }
  
  async function handlePerseguicao() {
    setLoadingPerseguicao(true);
    try {
      console.log(oportunidade)
      const ddd = (oportunidade.telefones?.[0]?.ddd).toString()
      let numero = (oportunidade.telefones?.[0]?.numero).toString()
      
      if (numero.length === 9) {
        numero = numero.substring(1);
      }

      const payload = {
        oportunidade_id: oportunidade.id,
        phone_number: `55${ddd}${numero}`
      };

      console.log(payload)

      await axios.post(webhookUrlPerseguicao, payload);
      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block" }}
          title="Sucesso!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Enviado para perseguição com sucesso!
        </ReactBSAlert>
      );
    } catch (err) {
      console.error("Erro ao enviar para perseguição", err);
      setAlert(
        <ReactBSAlert
          error
          style={{ display: "block" }}
          title="Falha!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Houve um erro ao enviar para perseguição.
        </ReactBSAlert>
      );
    } finally {
      setLoadingPerseguicao(false);
    }
  }

  return (
    <div>
      {alert}
      <div className="copilot-backdrop" onClick={onClose} />

      <div className="copilot-drawer">
        {/* Header */}
        <div className="copilot-header">
          <div className="copilot-header-info">
            <div className="copilot-header-logo-row">
              <div className="copilot-logo-circle">
                <img src="/boneco-ia.png" alt="Copiloto" className="copilot-logo-img" />
              </div>
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <h3 className="copilot-header-title">Copiloto Insights</h3>
                  <span className="copilot-online-dot" />
                </div>
                <p className="copilot-header-subtitle">Conte comigo para Insights de Vendas</p>
              </div>
            </div>
          </div>
          <button className="copilot-close-btn" onClick={onClose} aria-label="Fechar">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="copilot-body">
          {/* Nome do cliente em destaque */}
          <h2 className="copilot-client-name">{nomeOportunidade}</h2>

          {/* Insight Card — desativado temporariamente
          <div className="copilot-insight-card">
            <div className="copilot-insight-header">
              <span className="copilot-insight-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                </svg>
              </span>
              <span className="copilot-insight-name">Insight</span>
            </div>
            <p className="copilot-insight-text">
Posso gerar um resumo desta oportunidade com base nos comentários registrados, nas atividades realizadas por você e nas conversas trocadas no WhatsApp.
            </p>
            <button className="copilot-insight-btn">
              Gerar Resumo da Oportunidade
            </button>
          </div>
          */}

          {/* Suggested Actions */}
          <p className="copilot-actions-label">AÇÕES SUGERIDAS</p>

          <div className="copilot-actions-list">
            {actions.map((action) => {
              if (action.key === "perseguicao" && !webhookUrlPerseguicao) return null;

              return (
                <button
                  key={action.key}
                className="copilot-action-item"
                onClick={
                  action.key === "scripts" ? () => setScriptsOpen(true) :
                  action.key === "indicacao" ? handleIndicacao :
                  action.key === "perseguicao" ? handlePerseguicao :
                  undefined
                }
                disabled={
                  (action.key === "indicacao" && loadingIndicacao) ||
                  (action.key === "perseguicao" && loadingPerseguicao)
                }
              >
                <span className="copilot-action-icon-wrap">
                  {action.icon}
                </span>
                <span className="copilot-action-text">
                  <span className="copilot-action-label">
                    {action.key === "indicacao" && loadingIndicacao ? "Carregando..." :
                     action.key === "perseguicao" && loadingPerseguicao ? "Enviando..." : action.label}
                  </span>
                  <span className="copilot-action-subtitle">{action.subtitle}</span>
                </span>
              </button>
            );
          })}
          </div>
        </div>

        {/* Footer — Banner Vendedor Vencedor */}
        <div className="copilot-footer-banner">
          <span className="copilot-footer-banner-icon">🏆</span>
          <div className="copilot-footer-banner-body">
            <p className="copilot-footer-banner-title">Vendedor Vencedor</p>
            <p className="copilot-footer-banner-subtitle">Transforme seu objetivo de vida em conquista com o Plano Campeão</p>
          </div>
          <a href="https://vendedor-vencedor.playnee.com" target="_blank" rel="noopener noreferrer" className="copilot-footer-banner-cta">
            Ver →
          </a>
        </div>
      </div>

      <ScriptsModal
        isOpen={scriptsOpen}
        onClose={() => setScriptsOpen(false)}
        oportunidade={oportunidade}
      />

      {indicacaoAction && (
        <ReviewModal
          initialText={indicacaoAction.texto}
          type="whatsapp"
          onConfirm={() => setIndicacaoAction(null)}
          onCancel={() => setIndicacaoAction(null)}
        />
      )}
    </div>
  );
};

export default CopilotSidebar;
